// The outdoor football fields. Adding another one here is all it takes: it
// shows up in the admin type selector and gets its own card on the dashboard.
export const FIELD_TYPES = {
	'5': 'Fodboldbane 1',
	'6': 'Fodboldbane 2',
	'7': 'Fodboldbane 3',
	'8': 'Fodboldbane 4',
	'9': 'Fodboldbane 5',
	'10': 'Fodboldbane 6',
}

// Everything that can be picked as a type when creating an entry.
export const ENTRY_TYPES = {
	'1': 'Hallen',
	/* '2': 'Møde', */
	'4': 'Kultursalen',
	'3': 'Omklædning',
	...FIELD_TYPES,
}
